
export const convertRowHeaderConfigToCellData = ({rowHeaderData, rowIdx, convertToRichText}) => ({
  value: convertToRichText ? convertToRichText(rowHeaderData[rowIdx]) : rowHeaderData[rowIdx], //draftjs data shape
  readOnly: true,
  id: `rowHeaderCell_${rowIdx}`,
  isRowHeader: true
})